const setInitalVendorData = (state, payload = {}) => {
  const {vendor_ids} = payload;
  if (vendor_ids) {
    const oldVenodors = state;
    const newVendors = vendor_ids;
    return [...oldVenodors, ...newVendors];
  } else return state;
};

export default (state = [], action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      return setInitalVendorData(state, payload);
    }
  }
};
